module.exports = __webpack_public_path__ + "img/color5_on.c0a95056.png";